// Mock data for the application
// This will be replaced with actual API calls once backend is implemented

export const mockJobs = [
  {
    id: 1,
    title: 'Senior Embedded Systems Engineer',
    department: 'engineering',
    location: 'Bangalore, India',
    type: 'Full-time',
    experience: '5-8 years',
    description: 'Design and develop cutting-edge embedded systems for AI-powered devices. Work with latest microcontrollers and RTOS.',
  },
  {
    id: 2,
    title: 'AI/ML Engineer',
    department: 'ai',
    location: 'Bangalore, India / Remote',
    type: 'Full-time',
    experience: '3-5 years',
    description: 'Develop and deploy machine learning models for embedded systems. Experience with TensorFlow Lite and edge AI preferred.',
  },
  {
    id: 3,
    title: 'Hardware Design Engineer',
    department: 'engineering',
    location: 'Bangalore, India',
    type: 'Full-time',
    experience: '4-6 years',
    description: 'Design PCBs and hardware modules for wearable devices and display systems. Proficiency in CAD tools required.',
  },
  {
    id: 4,
    title: 'UX/UI Designer',
    department: 'design',
    location: 'Bangalore, India / Remote',
    type: 'Full-time',
    experience: '2-4 years',
    description: 'Create intuitive interfaces for smart devices and embedded systems. Experience with HMI design is a plus.',
  },
  {
    id: 5,
    title: 'Firmware Development Intern',
    department: 'engineering',
    location: 'Bangalore, India',
    type: 'Internship',
    experience: 'Fresh Graduate / Final Year',
    description: 'Learn and contribute to firmware development for embedded devices. Strong C/C++ programming skills required.',
  },
  {
    id: 6,
    title: 'Sales & Business Development Manager',
    department: 'sales',
    location: 'Bangalore, India',
    type: 'Full-time',
    experience: '5-7 years',
    description: 'Drive business growth and establish partnerships in embedded systems and AI solutions. B2B sales experience preferred.',
  },
];

export const mockContactSubmissions = [];
